import * as React from 'react';
import ErrorComponent from '@components/ErrorComponent/ErrorComponent';

type Props = {
    children?: React.ReactElement | React.ReactNode | null;
};

const error = {
    error: {
        error: 'Application error',
        error_description: 'Application error',
    },
    error_description: 'Application error',
    status: 0,
};

class ErrorBoundary extends React.Component<Props, { hasError: boolean }> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <ErrorComponent error={error}></ErrorComponent>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
